import { Component, OnChanges, SimpleChanges, ViewChild } from '@angular/core';

import { process, State } from '@progress/kendo-data-query';
import {
  Address,
  Agency,
  ApeCod,
  Civility,
  Contact,
  Country,
  LegalForm,
  SupplierContact,
  SupplierAgency,
  SupplierDescriptif,
  SimpleReponseResult,
  SaveStepParam,
  InseeEtablissement,
  InseeAdresseEtablissement,
  InseePeriodeEtablissement,
  Supplier,
  DuplicateSupplierParameters
} from '../../../all-models';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

import {
  ContactsService,
  SuppliersService,
  SharedDataService,
  InputCheckersService,
  DocumentsService
} from '../../../all-services';
import { ActivatedRoute, Router } from '@angular/router';
import {NgForm,  } from '@angular/forms';
import { DataStateChangeEvent, GridDataResult, SelectAllCheckboxState } from '@progress/kendo-angular-grid';
import { checkValidityEvent, SupplierDetailsStepBase } from '../supplier-details/suppliers-details-step-base';
import {  Observable, of, Subject } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { DuplicateSupplierModalComponent } from '../../../COMPOSANTS/duplicate-supplier-modal/duplicate-supplier-modal.component';



@Component({
  selector: 'app-supplier-descriptif',
  templateUrl: './supplier-descriptif.component.html',
  styleUrls: ['./supplier-descriptif.component.scss']
})
export class SupplierDescriptifComponent extends SupplierDetailsStepBase implements OnChanges {


  @ViewChild('ngFrmsupplierdescriptifs') public frmsupplierdescriptifs: NgForm;

  //public invalidContacts: SupplierContact[] = [];
  get invalidContacts():SupplierContact[]{
    return [this.emptySupplierContactRef,this.emptysupplierContact, ...this.supplier?.SupplierContacts]
    .filter(sc=>!!sc && !!(<any>sc).errors);

  }

  demandeurId: number = 0;
  public selectAllState: SelectAllCheckboxState = 'unchecked';
  private _topGroup: boolean = false;
  public get topGroup(): boolean {
    return this._topGroup;
  }
  public set topGroup(value: boolean) {
    this._topGroup = value;
    if (!value) this.supplier.GroupName = null;
  }
  public emptysupplierContact: SupplierContact = new SupplierContact();
  public get withAgencies(): boolean {
    return this.supplier && this.supplier.WithAgencies == 1;
  }
  public set withAgencies(value: boolean) {
    if (this.supplier) this.supplier.WithAgencies = (value ? 1 : 0);
  }
  private _isHQ: boolean = true;
  public get isHQ(): boolean {
    return this._isHQ;
  }
  public set isHQ(value: boolean) {
    this._isHQ = value;
    if (value) {
      this.supplier.HQSiret = null;
    } else {
      if (this.supplier.HQSiret == null) this.supplier.HQSiret = '';
    }
  }
  public gridData: GridDataResult;
  public state: State = {
    skip: 0,
    take: 10,
    sort: [{ field: "siret", dir: "asc" }]
  };
  public lstAgencies: InseeEtablissement[] = [];
  public selectedSiret: string[] = [];
  newAgencyVisible: boolean = false;


  
  constructor(
    public sharedDatasSvc: SharedDataService,
    public route: ActivatedRoute,
    private router: Router,
    private inputCheckersSvc: InputCheckersService,
    public suppliersSvc: SuppliersService,
    public docsSvc: DocumentsService,
    private modalService: NgbModal,
    public contactsSvc: ContactsService) {
    super(sharedDatasSvc, docsSvc, suppliersSvc, route, contactsSvc);
  }



  private dbSiret: string = null;
  ngOnInit(): void {
    this.ocurrentstep.showSaveButton = this._ShowSaveButton;
    this.bindSupplier();

  }

  onCheckValidity(event:checkValidityEvent):Observable<boolean | undefined>{
    if (event.stepNum!=this.screenValidity.step) return of(undefined);
    event.forms = [this.frmsupplierdescriptifs];
    let isValid: boolean = true; //= !this.formRevealErrors(this.frmsupplierdescriptifs);
    if (this.invalidContacts.some(sc => sc.ContactId != 0)){
      this.screenValidity.errorMessages.push('La_liste_de_contacts_est_incomplete_');
      isValid = false;
    }
    if (this.withAgencies && this.selectedAgencies.length == 0){
      this.screenValidity.errorMessages.push('Msg_avec_agence_sans_agence');
      isValid = false;
    }
    if ((!this.IsContactEmpty(this.emptysupplierContact.Contact)) && this.invalidContacts.some(sc => sc.ContactId == 0)){
      this.screenValidity.errorMessages.push('La_liste_de_contacts_est_incomplete_');
      isValid = false;
    }    
    return of(isValid);
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }




  findIntraTva(): void {
    if (this.supplier?.FunctionalId == 'tvaintra') this.inputCheckersSvc.findIntraTva(this.supplier, this.address);
  }

  private supplierBinding = false;
  bindSupplier(): void {
    if (this.supplier && this.supplier.Id) {
      this.supplierBinding = true;
      this.supplier.InternalDemandDate = new Date(this.supplier.InternalDemandDate);
      this._topGroup = (this.supplier.GroupName || '') != '';
      this.initEmptyContact();
      this.initEmptySupplierContactRef();
      this.initNewAgency();

      this._isHQ = (this.supplier.HQSiret == null);
      if ((this.supplier.Siret || '') != '') {
        this.dbSiret = this.supplier.Siret;
        this.GetSupplierInseeEtablissement(this.supplier.Siret);
      }
      this.supplierBinding = false;
    }
  }

  get inseeEtablissement(): InseeEtablissement | undefined {
    return this.supplier?.Etablissement;
  }

  public get Siret(): string {
    return this.supplier?.Siret;
  }
  public set Siret(value: string) {
    if (this.supplier) {
      this.supplier.Siret = value;
      if (value.length == 14) {
        this.GetSupplierInseeEtablissement(value);
      }
    }
  }
  findSiret():void {
    this.GetSupplierInseeEtablissement(this.supplier.Siret)
  }

  GetSupplierInseeEtablissement(siret : string): void {
    this.suppliersSvc.GetSupplierInseeEtablissement(this.supplier, false,false, siret)
      .subscribe(res => {
        this.alertIfSiretChange();
      });
  }

  //Décenché en quittant le controle Siret
  alertIfSiretChange(): void {
    if (this.inseeEtablissement) {
      if (this.inseeEtablissement.siret != this.supplier.Siret) {
        this.Label('Msg_Maj_Donnees_Etablissement_Insee')
          .subscribe(res => {
            let msg: string = res.replace('{0}', this.inseeEtablissement?.uniteLegale.denominationUniteLegale);
            this.sharedDatasSvc.confirm(msg,
              () => {
                this.suppliersSvc.bindInseeEtablissementToSupplier(this.supplier, this.inseeEtablissement, true);
              },
              null
            );
          });
      } else if (!this.supplier.TvaIntra || !this.supplier.ApeId) {
        //Pour mettre à jour intraTva et ApeCods si non renseignés
        this.suppliersSvc.bindInseeEtablissementToSupplier(this.supplier, this.inseeEtablissement, false);
      }
    }
  }

  private IsContactEmpty(contact: Contact) {
    if (contact == null) return true;
    return ((contact.Firstname || '') == '')
      && (contact.Lastname || '') == ''
      && (contact.Fonction || '') == ''
      && (contact.Phone || '') == ''
      && (contact.CellPhone || '') == ''
      && (contact.Email || '') == '';
  }



  get votreEntrepriseDisabled(): boolean {
    if (this.isCreatingSupplier) return false;
    if (!this.canModifySupplier()) return true;
    if (!this.sharedDatasSvc.profil) return false;
    return !this.sharedDatasSvc.checkProfilAccessPafSettings('FICHE_MAJ_VOTRE_ENT');
    //return ['CTRL_QUAL', 'ADMIN'].indexOf(this.sharedDatasSvc.profil?.Cod) < 0;
  }

  public get contactENDELDisabled(): boolean {
    if (this.sharedDatasSvc.profil?.Cod == 'FOURNISSEUR') return true;
    if (this.isCreatingSupplier) return false;
    if (!this.canModifySupplier()) return true;
    if (!this.sharedDatasSvc.profil) return false;
    return !this.sharedDatasSvc.checkProfilAccessPafSettings('FICHE_MAJ_CONTACT_ENDEL');
    //return ['ADMIN'].indexOf(this.sharedDatasSvc.profil?.Cod) < 0;
  }

  public get contactReferentDisabled(): boolean {
    if (this.isCreatingSupplier) return false;
    if (!this.canModifySupplier()) return true;
    if (!this.sharedDatasSvc.profil) return false;
    return !this.sharedDatasSvc.checkProfilAccessPafSettings('FICHE_MAJ_CONTACT_REFERENT');
    //return ['ACH_OPERAT', 'ACH_FAMHA', 'CTRL_QUAL', 'ADMIN'].indexOf(this.sharedDatasSvc.profil?.Cod) < 0;
  }

  public get contactAutrestDisabled(): boolean {
    if (this.isCreatingSupplier) return false;
    if (!this.canModifySupplier()) return true;
    if (!this.sharedDatasSvc.profil) return false;
    return !this.sharedDatasSvc.checkProfilAccessPafSettings('FICHE_MAJ_CONTACTS_AUTRES');
    //return ['ACH_OPERAT', 'ACH_OPERAT_2', 'ACH_FAMHA', 'CTRL_QUAL', 'QUAL', '3SE', 'ADMIN', 'FOURNISSEUR'].indexOf(this.sharedDatasSvc.profil?.Cod) < 0;
  }

  public get mieuxVousConnaitretDisabled(): boolean {
    if (this.isCreatingSupplier) return false;
    if (!this.canModifySupplier()) return true;
    if (!this.sharedDatasSvc.profil) return false;
    return !this.sharedDatasSvc.checkProfilAccessPafSettings('FICHE_MAJ_MIEUX_VOUS_CONNAITRE');
    //return ['ACH_OPERAT', 'ACH_FAMHA', 'CTRL_QUAL', 'ADMIN', 'FOURNISSEUR'].indexOf(this.sharedDatasSvc.profil?.Cod) < 0;
  }

  private _ShowSaveButton = (): any => {
    if (!this.canModifySupplier()) return false;
    if (!this.votreEntrepriseDisabled) return true;
    if (!this.contactENDELDisabled) return true;
    if (!this.contactReferentDisabled) return true;
    if (!this.contactAutrestDisabled) return true;
    if (!this.mieuxVousConnaitretDisabled) return true;
    return false;
  }

  ngOnChanges(changes: SimpleChanges): void {
    super.ngOnChanges(changes);
    if (changes['supplier']) {
      this.bindSupplier();
    }
    if (changes['ocurrentstep']) {
      setTimeout(() => {
        this.ocurrentstep.showSaveButton = (): boolean => { return this._ShowSaveButton() };
      }, 0);
      this.ocurrentstep.editingChange.subscribe(res => {
      });
    }
  }


  get uniqueIdToShow(): string {
    if ((this.supplier?.LegalForm?.Id || 0) == 0) {
      return 'postalcod';
    } else {
      if (this.supplier?.LegalForm?.Siret == 2) {
        return 'siret';
      } else if (this.supplier?.LegalForm?.Rsa == 2) {
        return 'rsa';
      } else if (this.supplier?.LegalForm?.TvaIntra == 2) {
        return 'tvaintra';
      } else if (this.supplier?.LegalForm?.Duns == 2) {
        return 'duns';
      } else {
        return 'postalcod';
      }
    }
  }


  private _savePendingEmptyContact(supplierContact:SupplierContact | undefined, setReferent: boolean):Observable<SupplierContact | undefined>{
    if (supplierContact == undefined){
      return of(undefined);
    }
    let subject = new Subject<SupplierContact | undefined>();
    let newContactId: number;
    let contactToAdd: Contact = supplierContact.Contact;
    if (!!(<any>(supplierContact)).existingContactWarning) {
      contactToAdd = (<any>(supplierContact)).existingContactWarning;
    }
    if (!this.IsContactEmpty(contactToAdd) || setReferent) {
      let $postContact : Observable<Contact>;
        if (!!contactToAdd.Id) {
          $postContact = of(contactToAdd);
        } else {
          if (this.invalidContacts.indexOf(supplierContact)>=0){
            //this.alertChampsEnEreur();
            subject.error({message:'contact incomplet'});
            return subject.asObservable();            
          }
          $postContact = this.contactsSvc.postContact(supplierContact.Contact);
        }
        $postContact
        .pipe(
          mergeMap(contact=>{
            newContactId = contact.Id;
            if (setReferent) {
              return this.suppliersSvc.addContactAsReferent(this.supplier.Id, contact.Id);   
            } else {
              return this.suppliersSvc.addContact(this.supplier.Id, contact.Id, supplierContact.CreateAccount);   
            }      
          }),
          mergeMap((newReferent:SupplierContact)=>{
             return this.loadContacts();           
          })
        ).subscribe((results:SupplierContact[])=>{
            supplierContact.Contact = new Contact();
            // if (this.invalidContacts.indexOf(supplierContact)>=0){
            //   this.invalidContacts = this.invalidContacts.filter(item=> item !=supplierContact);
            // }
            subject.next(results.find(item=>item.ContactId == newContactId));
        },
        (reason)=> subject.error(reason)
        );
    } else {
      subject.next(undefined);
    }
    return subject.asObservable();
  }


  save(param: SaveStepParam): void {
    if (param.nextAction == 'forceScreen') {
      super.save(param);
      return;
    }
    this.CanSave(this.frmsupplierdescriptifs, param);
    if (!param.canSave && !param.noSaveAllowed(this.currentStep)) return;

    // Parmis les contacts déjà enregistrés, il y en a en erreur
    if (this.invalidContacts.length>0) {
      param.canSave = false;
      if (!param.noSaveAllowed(this.currentStep)) {
        this.alertChampsEnEreur();
        return;
      }
    }

    if (this.withAgencies && this.selectedAgencies.length == 0) {
      this.sharedDatasSvc.pafAlert('Msg_avec_agence_sans_agence');
      return;
    }

    //Si pas de référent, on l'ajoute
    if (this.emptySupplierContactRef){
      this._savePendingEmptyContact(this.emptySupplierContactRef,true).subscribe((newRefSc: SupplierContact)=>{
        this.save(param);   
      },
      (reason:any)=>{      
        param.canSave = false;
        if (!param.noSaveAllowed(this.currentStep)) {
          this.alertChampsEnEreur();
          return;
        }
      });
      return;
    }

    // Si on a un contact en attente d'ajout, on l'ajoute
    if (this.emptysupplierContact && !this.IsContactEmpty(this.emptysupplierContact?.Contact)){
      this._savePendingEmptyContact(this.emptysupplierContact,false).subscribe(res=>{
        this.save(param);   
      },
      (reason:any)=>{      
        param.canSave = false;
        if (!param.noSaveAllowed(this.currentStep)) {
          this.alertChampsEnEreur();
          return;
        }
      });
      return;
    }
    

    let parameters: SupplierDescriptif = new SupplierDescriptif();
    Object.keys(parameters).forEach((propName: string) => {
      (<any>parameters)[propName] = (<any>this.supplier)[propName];
    });
    parameters.LegalFormId = this.supplier.LegalForm?.Id || null;
    parameters.ApeId = this.supplier.ApeCod?.Id || null;
    parameters.FunctionalId = this.uniqueIdToShow;
    if (!this.showSiret) parameters.Siret = '';
    if (!this.showIntraTva) parameters.TvaIntra = '';
    if (!this.showRsa) parameters.Rsa = '';
    if (!this.showDuns) parameters.Duns = '';


    parameters.InternalContactFirstname = this.demandeur?.Firstname;
    parameters.InternalContactLastname = this.demandeur?.Lastname;
    parameters.InternalContactEmail = this.demandeur?.Email;

    if (param.nextAction == 'next') parameters.RefStep++;
    if (param.nextAction == 'previous') parameters.RefStep--;

    if (!param.canSave) {
      if (param.noSaveAllowed(this.currentStep)) {
        this.msgEcranIncomplet.subscribe(msg=>{
        this.sharedDatasSvc.confirm(msg,
          (): void => super.save(param),
          null);
        });
        return;
      }
    }

    //Si on a décoché avec agences, on supprime les agences autres que celle lié au fournisseur
    if (!this.withAgencies) {
      parameters.SupplierAgencies = parameters.SupplierAgencies.filter(sa => sa.IsSupplierAgency == 1);
    }

    parameters.SupplierAgencies.find(sa => sa.IsSupplierAgency == 1).Agency.Address.CountryId = this.country.Id;
    this.suppliersSvc.patchSupplierDescriptif(this.supplier.Id, parameters)
      .subscribe((res: SimpleReponseResult) => {
        if (res.Ok) {
          this.createPendingAccounts(param)
            .subscribe(res => {
              super.save(param);
            });

        } else {
          this.sharedDatasSvc.alert(res.Message);
        }
      });
  }



  createPendingAccounts(param: SaveStepParam): Observable<SaveStepParam> {
    let subject: Subject<SaveStepParam> = new Subject<SaveStepParam>();
    if (param.nextAction == 'screen' && this.supplierStatutCod == '800'
      && this.supplier.SupplierContacts.some(sc => sc.CreateAccount == 1)) {
      this.suppliersSvc.CreatePendingAccounts(this.supplier.Id)
        .subscribe((result: SimpleReponseResult) => {
          if (result.Message) {
            this.sharedDatasSvc.informe(result.Message,
              (): void => {
                if (result.Ok) {
                  subject.next(param);
                }
              });
          } else {
            //super.save(param);
            subject.next(param);
          }
        });
    } else {
      return of(param);
    }
    return subject.asObservable();
  }

  public get showDuns(): boolean {
    return this.dunsAccess != 0;
  }
  public get showSiret(): boolean {
    return this.isFranceGuyaneReunion && this.siretAccess != 0;
  }
  public get showRsa(): boolean {
    return this.isFranceGuyaneReunion && this.rsaAccess != 0;
  }
  public get showIntraTva(): boolean {
    if (!this.supplier) return false;
    return this.country
      && this.country.TopUE == 1
      && this.tvaIntraAccess != 0;
  }

  public get isFranceGuyaneReunion(): boolean {
    if (!this.country) return false;
    return ['FR', 'GF', 'RE'].indexOf(this.country.CountryCod2) >= 0;
  }

  get siretAccess(): number {
    if (!this.supplier?.LegalForm) return 0;
    return this.supplier.LegalForm.Siret;
  }
  get tvaIntraAccess(): number {
    if (!this.supplier?.LegalForm) return 0;
    return this.supplier.LegalForm.TvaIntra;
  }
  get rsaAccess(): number {
    if (!this.supplier?.LegalForm) return 0;
    return this.supplier.LegalForm.Rsa;
  }
  get dunsAccess(): number {
    if (!this.supplier?.LegalForm) return 0;
    return this.supplier.LegalForm.Duns;
  }

  public get supplierAgency(): SupplierAgency {
    return this.supplier && this.supplier.SupplierAgencies
      ? this.supplier.SupplierAgencies.find(supAg => supAg.IsSupplierAgency == 1) : null;
  }

  public get selectedAgencies(): Agency[] {
    if (!this.supplier || !this.supplier.SupplierAgencies) return [];
    return this.supplier.SupplierAgencies.filter(sag => sag.IsSupplierAgency == 0).map(sag => sag.Agency);
  }


  public get agency(): Agency {
    return this.supplierAgency == null ? null : this.supplierAgency.Agency;
  }
  public set agency(value: Agency) {
    if (this.supplierAgency) this.supplierAgency.Agency = value;
  }

  public get address(): Address {
    if (!this.agency) return null;
    return this.agency.Address;
  }
  public set address(value: Address) {
    if (this.agency) this.agency.Address = value;
  }

  public get country(): Country {
    if (!this.address) return null;
    return this.address.Country;
  }
  public set country(value: Country) {
    if (this.address) this.address.Country = value;
    if (!this.supplierBinding) this.supplier.LegalForm = null;
  }

  

  public get supplierContactRef(): SupplierContact | undefined {
    return this.supplier.SupplierContacts.find(c => c.IsReferent == 1);
  }
  public set supplierContactRef(value: SupplierContact) {
    if (value) {
      this.supplier.SupplierContacts.forEach((sc, i) => sc.IsReferent = (sc.ContactId == value.ContactId ? 1 : 0));
    }
  }

  public emptySupplierContactRef : SupplierContact | undefined;


  get UniciteIntraTvaActive(): boolean {
    if (!this.address) return false;
    return this.inputCheckersSvc.UniciteIntraTvaActive(this.address);
  }


  initEmptyContact(): void {
    this.emptysupplierContact = new SupplierContact();
    this.emptysupplierContact.ContactId = 0;
    this.emptysupplierContact.Contact = new Contact();
    this.emptysupplierContact.Contact.Civility = new Civility();
    this.emptysupplierContact.SupplierId = this.supplier.Id;
  }

  initEmptySupplierContactRef(): void {
    if (!this.supplierContactRef){
      this.emptySupplierContactRef = new SupplierContact();
      this.emptySupplierContactRef.ContactId = 0;
      this.emptySupplierContactRef.Contact = new Contact();
      this.emptySupplierContactRef.Contact.Civility = new Civility();
      this.emptySupplierContactRef.SupplierId = this.supplier.Id;
    } else {
      this.emptySupplierContactRef = undefined;
    }
  }


  loadContacts(): Observable<SupplierContact[]> {
    let subject = new Subject<SupplierContact[]>();
    this.suppliersSvc.reloadContacts(this.supplier)
      .subscribe(scs => {
        this.initEmptyContact();
        this.initEmptySupplierContactRef();
        subject.next(scs);
      });
    return subject.asObservable();
  }




  private createPendingAccountsIfCreated(): Observable<SimpleReponseResult> {
    if (this.supplierStatutCod >= '100') {
      return this.suppliersSvc.CreatePendingAccounts(this.supplier?.Id);
    } else {
      let simpleReponseResult: SimpleReponseResult = new SimpleReponseResult();
      simpleReponseResult.Id = this.supplier?.Id;
      simpleReponseResult.Ok = true;
      return of(simpleReponseResult);
    }
  }


  private _addContactToSupplier(suppId: number, contId: number, createAccount: number): Observable<SupplierContact> {
    let subject = new Subject<SupplierContact>();
    this.sharedDatasSvc.WindowLock();
    this.suppliersSvc.addContact(suppId, contId, createAccount)
      .subscribe({
        next: addedContact => {
          this.createPendingAccountsIfCreated()
            .subscribe({
              next: (response: SimpleReponseResult) => {
                this.loadContacts()
                  .subscribe({next:(results: SupplierContact[]) => {
                    if (response.Message) {
                      this.sharedDatasSvc.informe(response.Message);
                    }
                    subject.next(addedContact);
                  }
              });
              },
              error: (reason: any) => subject.error(reason)
            });
        },
        error: (error) => {
          this.sharedDatasSvc.alert(error);
          subject.error(error);
        },
        complete: () => { this.sharedDatasSvc.WindowUnlock(); }
      });
    return subject.asObservable();
  }

  addContact(event: any): void {
    const suppCont: SupplierContact = <SupplierContact>event;
    if (!suppCont.Contact) return;
    let cont: Contact = suppCont.Contact;
    if (!cont.LngCod) cont.LngCod = this.supplier?.LngCod;
    if (!cont.Id) {
      this.contactsSvc.postContact(cont)
        .subscribe(res => {
          this._addContactToSupplier(suppCont.SupplierId, res.Id, suppCont.CreateAccount);
        });
    } else {
      //On ajoute un contact déjà existant.
      this._addContactToSupplier(suppCont.SupplierId, cont.Id, suppCont.CreateAccount);
    }
  }

  addContactReferent(contactReferent:SupplierContact): void {
    this._savePendingEmptyContact(contactReferent,true)
    .subscribe();
    // const suppCont: SupplierContact = <SupplierContact>event;
    // if (!suppCont.Contact) return;
    // let cont: Contact = suppCont.Contact;
    // if (!cont.LngCod) cont.LngCod = this.supplier?.LngCod;
    // let observableCont: Observable<Contact>;
    // if (!cont.Id) {
    //   observableCont = this.contactsSvc.postContact(cont);
    // } else {
    //   observableCont = of(cont);
    // }
    // observableCont.subscribe(res => {
    //   this._addContactToSupplier(suppCont.SupplierId, res.Id, suppCont.CreateAccount)
    //     .subscribe((addedSupCont: SupplierContact) => {
    //       this.suppliersSvc.setContactReferent(this.supplier?.Id, addedSupCont.ContactId)
    //         .subscribe(res => {
    //           if (!res.Ok) {
    //             this.sharedDatasSvc.alert(res.Message);
    //           } else {
    //             this.loadContacts().subscribe();
    //           }
    //         });
    //     });
    // });



  }

  delContact(suppCont: SupplierContact): void {
    this.sharedDatasSvc.pafConfirm('Msg_Supprimer_le_contact',
      (): void => {
        if (this.isEditing() && suppCont.ContactId) {
          this.suppliersSvc.removeContact(suppCont.SupplierId, suppCont.ContactId)
            .subscribe(res => {
              if (!res.Ok) {
                this.sharedDatasSvc.alert(res.Message);
              } else {
                this.loadContacts().subscribe();
              }
            });
        }
      }, null);
  }

  updateContact(event: any): void {
    const suppCont: SupplierContact = <SupplierContact>event;
    if (suppCont.Contact && suppCont.Contact.Id > 0) {
      if (!suppCont.Contact.LngCod) suppCont.Contact.LngCod = this.supplier?.LngCod;
      this.contactsSvc.putContact(suppCont.ContactId, suppCont.Contact)
        .subscribe((res: Contact) => {
          //Mise à jour des infos de creation de compte si non renseignées
          this._addContactToSupplier(suppCont.SupplierId, res.Id, suppCont.CreateAccount).subscribe();
        });
    }
  }

  searchAgencies(searchComplete: () => any): void {
    if ((this.supplier?.Siret || '').length < 9) {
      this.sharedDatasSvc.pafAlert('Msg_Siret_Manquant', null);
      return;
    }
    this.sharedDatasSvc.WindowLock();
    //this.inputCheckersSvc.getInseeEtablissements(this.supplier.Siret)
    this.inputCheckersSvc.getSupplierInseeEtablissements(this.supplier.Id, this.supplier.Siret)
      .subscribe({
        next:(res: InseeEtablissement[]) => {
          let otherEtabs = res.filter(e => e.siret != this.supplier.Siret);
        this.lstAgencies = otherEtabs;
        this.gridData = process(this.lstAgencies, this.state);
        if (searchComplete) {
          searchComplete();
        }
      },
        error:(response: any) => this.sharedDatasSvc.alert("Erreur renvoyée par le service Api Insee:<BR\>" + response.error?.Message || response.error || response),
        complete:(): void => this.sharedDatasSvc.WindowUnlock()
      });
  }


  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.gridData = process(this.lstAgencies, this.state);
  }

  public onSelectedKeysChange(keys: any[]): void {
    this.selectedSiret = keys;
  }

  public getEtabLissementEnseigne(etb: InseeEtablissement) {
    let p: InseePeriodeEtablissement = etb.periodesEtablissement[0];
    let enseignes: string[] = [];
    let denominationUniteLegale: string = (etb.uniteLegale?.denominationUniteLegale || '');
    enseignes.push((p.denominationUsuelleEtablissement || ''));
    enseignes.push((p.enseigne1Etablissement || ''));
    enseignes.push((p.enseigne2Etablissement || ''));
    enseignes.push((p.enseigne3Etablissement || ''));
    enseignes = enseignes.distinct().filter(s => s != '' && s != denominationUniteLegale);

    return denominationUniteLegale + ((enseignes.length == 0) ? '' : ' (' + enseignes.join(' ') + ')');
  }

  public getEtabLissementAdresse(etb: InseeEtablissement): string {
    let a: InseeAdresseEtablissement = etb.adresseEtablissement;
    let tmp: string[] = [];
    tmp.push(a.numeroVoieEtablissement || '');
    tmp.push(a.typeVoieEtablissement);
    tmp.push(a.libelleVoieEtablissement || '');
    tmp.push(a.complementAdresseEtablissement) || '';
    tmp.push(a.codePostalEtablissement || '');
    tmp.push(a.libelleCommuneEtablissement || '');
    tmp.push(a.codeCedexEtablissement) || '';
    tmp.push(a.libelleCommuneEtrangerEtablissement || '');
    return tmp.filter(s => (s || '') != '').join(' ').trim();
  }


  triggerModal(content: any) {

    this.searchAgencies((): void => {
      this.selectedSiret = this.lstAgencies.filter(etb => this.supplier.SupplierAgencies.some(ag => ag.Agency.Siret == etb.siret)).map(etb => etb.siret);
      this.modalService.open(
        content,
        {
          ariaLabelledBy: 'modal-basic-title',
          size: 'xl',
          centered: true,
          animation: true,
          scrollable: true
        }).result;
    });

  }

  importerSelection(): void {
    let alreadySelected = this.selectedAgencies.filter(a => this.selectedSiret.some(s => s == a.Siret));
    if (alreadySelected.length > 0) {
      this.sharedDatasSvc.pafConfirm('Msg_agence_deja_selectionnee', (): void => this._importConfirme(), null);
    } else {
      this._importConfirme();
    }
  }

  private _importConfirme(): void {
    let lstSirenAg: InseeEtablissement[] = this.lstAgencies.filter(etb => this.selectedSiret.indexOf(etb.siret) >= 0);
    lstSirenAg.forEach((etb: InseeEtablissement) => {
      let agence: Agency = new Agency();
      let adr: InseeAdresseEtablissement = etb.adresseEtablissement;
      agence.Siret = etb.siret;
      agence.Designation = this.getEtabLissementEnseigne(etb);
      agence.Address = new Address();
      let tmp: string[] = [];
      agence.Address.AddrNum = adr.numeroVoieEtablissement;
      tmp.push(adr.typeVoieEtablissement);
      tmp.push(adr.libelleVoieEtablissement);
      agence.Address.Addr1 = tmp.filter(s => (s || '') != '').join(' ').trim();
      tmp = [];
      tmp.push(adr.complementAdresseEtablissement);
      agence.Address.Addr2 = tmp.filter(s => (s || '') != '').join(' ').trim();
      agence.Address.PostalCod = adr.codePostalEtablissement;
      tmp = [];
      tmp.push(adr.libelleCommuneEtablissement || '');
      tmp.push(adr.libelleCommuneEtrangerEtablissement || '');
      tmp.push(adr.libellePaysEtrangerEtablissement || '');
      agence.Address.City = tmp.filter(s => (s || '') != '').join(' ').trim();
      agence.IsHeadQuarter = (etb.etablissementSiege ? 1 : 0);
      this.addAgency(agence);
    });
    this.modalService.dismissAll();
  }

  deleteAgency(agency: Agency): void {
    if (!this.supplier) return;
    if (!this.supplier.SupplierAgencies) return;
    this.supplier.SupplierAgencies = this.supplier.SupplierAgencies.filter(sag => sag.Agency && sag.Agency.Siret != agency.Siret);
  }

  initNewAgency(): void {
    this.newAgency = new Agency();
    this.newAgency.Address = new Address();
    this.newAgencyVisible = false;
  }
  public newAgency: Agency = new Agency();

  addAgency(agency: Agency): void {
    let supplierAgency: SupplierAgency = this.supplier.SupplierAgencies.find(a => a.Agency && a.Agency.Siret == agency.Siret);
    if (!supplierAgency) {
      supplierAgency = new SupplierAgency();
      supplierAgency.IsSupplierAgency = 0;
      this.supplier.SupplierAgencies.push(supplierAgency);
    }
    supplierAgency.SupplierId = this.supplier.Id;
    supplierAgency.Agency = agency;
    if (agency == this.newAgency) this.initNewAgency();
  }




  // ContactRowValidChange(event: any): void {
  //   let suppContactKv: KeyValue<SupplierContact, boolean> = <KeyValue<SupplierContact, boolean>>event;
  //   let sc: SupplierContact = this.invalidContacts.find(t => t.SupplierId == suppContactKv.key.SupplierId && t.ContactId == suppContactKv.key.ContactId);
  //   if (suppContactKv.value == true) {
  //     //on supprime le contact des contacts invalides
  //     if (sc != null) this.invalidContacts = this.invalidContacts.filter(t => t != sc);
  //   } else {
  //     if (sc == null) this.invalidContacts.push(suppContactKv.key);
  //   }
  // }


  setSupplierContactAsReferent(sc: SupplierContact): void {
    if (sc.ContactId > 0 && (sc.CreateAccount || 0) > 0 && sc.IsReferent != 1) {
      this.Label('Msg_confirmer_referent').subscribe(res => {
        let msg = res.replace('{0}', sc.Contact?.Firstname + ' ' + sc.Contact?.Lastname);
        this.sharedDatasSvc.confirm(msg, (): void => {
          this.suppliersSvc.setContactReferent(this.supplier?.Id, sc.ContactId)
            .subscribe(res => {
              if (!res.Ok) {
                this.sharedDatasSvc.alert(res.Message);
              } else {
                this.loadContacts().subscribe();
              }
            });
        }, null);


      });
    }
  }

  toggleNewAgencyVisible(): void {
    this.newAgencyVisible = !this.newAgencyVisible;
    if (!this.newAgencyVisible) {
      this.newAgency = new Agency();
      this.newAgency.Address = new Address();
    }
  }


  DemandeRefInputDisabled(controlName?: string): boolean {
    if (!this.supplier) return true;
    if (!this.isCreatingSupplier) return (this.sharedDatasSvc.profil?.Cod == 'FOURNISSEUR');
    if (this.sharedDatasSvc.profil?.Cod == 'ADMIN') return false;
    if (this.supplier.SupplierStatut && this.supplier.SupplierStatut.Cod == '010') return false;
    if (!controlName) return true;
    return (this.supplier.FunctionalId == controlName.toLowerCase());
  }

  get apeCodRequired(): boolean {
    return this.siretAccess != 0 && (this.supplier.Siret || '') != '';
  }

  get supplierWebSiteUri(): string {

    if (!this.supplier?.WebSite) {
      return '';
    } else if (this.supplier.WebSite.toLowerCase().indexOf('http') < 0) {
      return 'http://' + this.supplier.WebSite;
    } else {
      return this.supplier.WebSite;
    }
  }


  /**  Duplication fournisseur */
  duplicatedSupplier?: Supplier = undefined;

  dupInseeEtablissement?: InseeEtablissement = null;
  get canDuplicateSupplier(): boolean {
    return this.sharedDatasSvc.checkProfilAccessPafSettings('FICHE_DUPLICATE_SUPPLIER')
      && this.supplierStatutCod >= '800';
  }



  triggerModalDuplicate() {
    if (!this.supplier) return;
    this.duplicatedSupplier = new Supplier();
    this.dupInseeEtablissement = null;
    this.duplicatedSupplier.FunctionalId = this.supplier.FunctionalId;

    const duplicateModal: NgbModalRef = this.modalService.open(
      DuplicateSupplierModalComponent,
      {
        ariaLabelledBy: 'modal-basic-title',
        size: 'md',
        centered: true,
        animation: true,
        scrollable: true
      });
    duplicateModal.componentInstance.supplierSrc = this.supplier;
    duplicateModal.result.then((parameters: DuplicateSupplierParameters) => {
      this.suppliersSvc.DuplicateSupplier(parameters)
        .subscribe({
          next:(response: SimpleReponseResult) => {
          let newSupplierId: number = response.Id;
          this.router.navigate([`supplier-details/${newSupplierId}/duplicated`]);
        },
         error: (reason: any) => {
            this.sharedDatasSvc.alert(reason.error?.Message || reason.error);
          }
    });
    }).catch((error) => {
      console.log(error);
    });
  }

  lstLegalforms:LegalForm[]=[];
  reloadlstLegalforms(country?: Country): void{
    this.lstLegalforms = this.sharedDatasSvc.legalForms
    .filter(lf =>  lf.CountryId === country?.Id);
  }


}
